export default __webpack_public_path__ + "4b61dd373e3b4248ee1b908e92497a3d.png";